export enum WalletType {
	CONGENER = 'CONGENER',
	CONJUGATED = 'CONJUGATED',
	DEFAULT = 'DEFAULT',
}
